import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "no-data"
}
const _hoisted_5 = {
  key: 2,
  class: "no-data"
}

import AccordionCardInfoDisplay from './AccordionCardInfoDisplay.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { computed, ref } from 'vue'
import { useSelectionStore } from '@/pinia/selection'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

type indoorDataItem = {
  title: string
  value: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InfoDisplayIndoorDataCard',
  props: {
    showForEntityTypes: {},
    indoorData: {}
  },
  setup(__props: any) {


const { t } = useI18n()
const store = useStore()
const selectionStore = useSelectionStore()
const { clickedEntityType } = storeToRefs(selectionStore)
const title = t('general__text__indoor-data')
const isExpanded = ref(false)
const isLoadingSensordata = computed(() => store.state.planview.isLoadingSensordata)
function handleClick() {
  isExpanded.value = !isExpanded.value
}

return (_ctx: any,_cache: any) => {
  return (_ctx.showForEntityTypes.includes(_unref(clickedEntityType)))
    ? (_openBlock(), _createBlock(AccordionCardInfoDisplay, {
        key: 0,
        heading: _unref(title),
        isExpanded: isExpanded.value,
        onOnClicked: handleClick
      }, {
        content: _withCtx(() => [
          (!isLoadingSensordata.value && _ctx.indoorData.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indoorData, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "indoor-data"
                  }, [
                    (item.value)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_2, _toDisplayString(item.title), 1))
                      : _createCommentVNode("", true),
                    (item.value)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_3, _toDisplayString(item.value), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : (isLoadingSensordata.value && !_ctx.indoorData.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(PulseLoader, {
                    loading: true,
                    color: "#3F46D6"
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('general__data__no-data-published')), 1)
                ]))
        ]),
        _: 1
      }, 8, ["heading", "isExpanded"]))
    : _createCommentVNode("", true)
}
}

})